export default {
  termsOfUse: '개인정보처리방침',
  privacyPolicy: '쿠키정책',
  cookiesPolicy: '이용약관',
  careers: '채용',

  connectSocialMedia: '소셜 미디어에서 연결',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
